import { SubflowMessengerAction } from 'lib-shared-types-api';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';

/**
 * There can be multiple return nodes in a subflow. We only want to consider the
 * return nodes that are descendants of the init node for creating exit paths.
 */
export function isReturnNodeDescendantOfInitNode(
  action: SubflowMessengerAction,
  actions: SubflowMessengerAction[],
): boolean {
  if (action.nodeType === FlowNodeTypes.INIT) {
    return true;
  }

  const parentId = action.parentId;

  if (!parentId) {
    return false;
  }

  const parentNode = actions.find((action) => action.id === parentId);

  if (!parentNode) {
    return false;
  }

  return isReturnNodeDescendantOfInitNode(parentNode, actions);
}
